import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'settings-add-btn',
	template: require('./settings-add-btn.html'),
	styles: [require('./settings-add-btn.scss')]
})
export class SettingsAddBtnComponent {
	@Input() text: string;
	@Input() disable: boolean;
	@Output() onBtnClick: EventEmitter<void> = new EventEmitter<void>();

	constructor() {}

	onAddBtnClick(): void {
		this.onBtnClick.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/settings-add-btn/settings-add-btn.ts